// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
// Solid Icons
import {
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowTurnDown,
  faArrowUp,
  faArrowUpFromBracket,
  faBars,
  faBell,
  faBug,
  faBuilding,
  faCalendar,
  faCalendarDays,
  faCalendarCheck,
  faCalendarPlus,
  faCalendarXmark,
  faCamera,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCartShopping,
  faChartBar,
  faChartColumn,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleHalfStroke,
  faCircleInfo,
  faCircleStop,
  faCircleXmark,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faClone as faCloneSolid,
  faCog,
  faCoins,
  faComment,
  faComments,
  faCopy,
  faCrop,
  faDatabase,
  faDiamondTurnRight,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEllipsisVertical,
  faEnvelope,
  faEllipsis,
  faExpand,
  faEye,
  faHand,
  faEyeSlash,
  faFile,
  faFileCircleXmark,
  faFileContract,
  faFileExcel,
  faFileImage,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFilePen,
  faFileWord,
  faFilter,
  faFloppyDisk,
  faFolder,
  faFolderOpen,
  faGasPump,
  faGripVertical,
  faHandshake,
  faHandshakeSlash,
  faHashtag,
  faLayerGroup,
  faLink,
  faLinkSlash,
  faListCheck,
  faLocationCrosshairs,
  faLocationDot,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMap,
  faMessage,
  faMinus,
  faMobileScreen,
  faMoneyBillWave,
  faMugHot,
  faNoteSticky,
  faObjectGroup,
  faObjectUngroup,
  faPalette,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faPaste,
  faPeopleArrows,
  faPenToSquare,
  faPerson,
  faPersonDigging,
  faPhone,
  faPlus,
  faPrint,
  faQuestion,
  faReceipt,
  faRightFromBracket,
  faRightToBracket,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faScissors,
  faScrewdriverWrench,
  faSliders,
  faTableColumns,
  faTag,
  faTimeline,
  faTrashCan,
  faTrashRestore,
  faTriangleExclamation,
  faTruck,
  faTruckRampBox,
  faUpRightFromSquare,
  faUser,
  faUserGroup,
  faUserLock,
  faUserPen,
  faUserPlus,
  faUserXmark,
  faUsers,
  faWandMagicSparkles,
  faWrench,
  faXmark
} from "@fortawesome/free-solid-svg-icons"

// Regular Icons
import { faClone as faCloneRegular } from "@fortawesome/free-regular-svg-icons"

// Brand Icons
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"
// Add to Library
import { library } from "@fortawesome/fontawesome-svg-core"
library.add(
  faAddressCard,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsRotate,
  faArrowTurnDown,
  faArrowUp,
  faArrowUpFromBracket,
  faBars,
  faBell,
  faBug,
  faBuilding,
  faCalendar,
  faCalendarDays,
  faCalendarCheck,
  faCalendarPlus,
  faCalendarXmark,
  faCamera,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCartShopping,
  faChartBar,
  faChartColumn,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleHalfStroke,
  faCircleInfo,
  faCircleStop,
  faCircleXmark,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faCloneRegular,
  faCloneSolid,
  faCog,
  faCoins,
  faComment,
  faComments,
  faCopy,
  faCrop,
  faDatabase,
  faDiamondTurnRight,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEllipsisVertical,
  faEnvelope,
  faEllipsis,
  faExpand,
  faEye,
  faHand,
  faEyeSlash,
  faFile,
  faFileCircleXmark,
  faFileContract,
  faFileExcel,
  faFileImage,
  faFileInvoice,
  faFileLines,
  faFilePdf,
  faFilePen,
  faFileWord,
  faFilter,
  faFloppyDisk,
  faFolder,
  faFolderOpen,
  faGasPump,
  faGripVertical,
  faHandshake,
  faHandshakeSlash,
  faHashtag,
  faLayerGroup,
  faLink,
  faLinkSlash,
  faListCheck,
  faLocationCrosshairs,
  faLocationDot,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMap,
  faMessage,
  faMinus,
  faMobileScreen,
  faMoneyBillWave,
  faMugHot,
  faNoteSticky,
  faObjectGroup,
  faObjectUngroup,
  faPalette,
  faPaperclip,
  faPaperPlane,
  faParagraph,
  faPaste,
  faPeopleArrows,
  faPenToSquare,
  faPerson,
  faPersonDigging,
  faPhone,
  faPlus,
  faPrint,
  faQuestion,
  faReceipt,
  faRightFromBracket,
  faRightToBracket,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faScissors,
  faScrewdriverWrench,
  faSliders,
  faTableColumns,
  faTag,
  faTimeline,
  faTrashCan,
  faTrashRestore,
  faTriangleExclamation,
  faTruck,
  faTruckRampBox,
  faUpRightFromSquare,
  faUser,
  faUserGroup,
  faUserLock,
  faUserPen,
  faUserPlus,
  faUserXmark,
  faUsers,
  faWandMagicSparkles,
  faWhatsapp,
  faWrench,
  faXmark
)
export default FontAwesomeIcon
